// LASH GLOW BOCA — THEME JS
(function() {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function() {

    // Nav scroll state
    var nav = document.querySelector('.nav');
    if (nav) {
      var update = function() {
        if (window.scrollY > 12) nav.classList.add('scrolled');
        else nav.classList.remove('scrolled');
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
    }

    // Service filter pills
    var pills = document.querySelectorAll('.menu-filters .filter-pill');
    var cards = document.querySelectorAll('.menu-grid .svc-card');
    pills.forEach(function(p) {
      p.addEventListener('click', function() {
        pills.forEach(function(x) { x.classList.remove('active'); });
        p.classList.add('active');
        var f = p.getAttribute('data-filter');
        cards.forEach(function(c) {
          var cat = c.getAttribute('data-cat') || '';
          c.style.display = (f === 'all' || cat.indexOf(f) !== -1) ? '' : 'none';
        });
      });
    });

    // FAQ accordion (single-open)
    var items = document.querySelectorAll('.faq-item');
    items.forEach(function(item) {
      var q = item.querySelector('.faq-q');
      if (!q) return;
      q.addEventListener('click', function() {
        var wasOpen = item.classList.contains('open');
        items.forEach(function(o) { o.classList.remove('open'); });
        if (!wasOpen) {
          item.classList.add('open');
          q.setAttribute('aria-expanded', 'true');
        } else {
          q.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Smooth scroll for in-page anchors
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href === '#' || href === '#!') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.pushState) history.pushState(null, '', href);
    });

  });
})();
